module.exports = __webpack_public_path__ + "static/media/img6.7fc04164.jpg";